export const PLAN_LEVEL = {
  FREE: 0,
  PREMIUM: 1,
  FAMILY: 2
};

export const PLAN_TYPES = {
  FREE: 'FREE',
  PREMIUM: 'PREMIUM',
  FAMILY: 'FAMILY'
};

export const PLAN_ORDER = [PLAN_TYPES.FREE, PLAN_TYPES.PREMIUM, PLAN_TYPES.FAMILY];

export const PLAN_COLORS = {
  FREE: "var(--mainColor)",
  PREMIUM: "gray",
  FAMILY: "orange",
};

export const PLAN_DESCRIPTIONS = {
  FAMILY: "plan_family_desc",
  PREMIUM: "premium_plan_desc",
  FREE: "free_plan_desc",
};